import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/admin`;

const getAuthHeader = () => {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handleAuthError = (error) => {
  // If token is invalid or expired, clear it and redirect to login
  if (error.response && (error.response.status === 401 || error.response.status === 403)) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_token_expiry');
    // Redirect to login if on an admin page
    if (window.location.pathname.includes('/admin/') && !window.location.pathname.includes('/admin/login')) {
      window.location.href = '/admin/login';
    }
  }
  throw error;
};

const isTokenExpired = () => {
  const expiry = localStorage.getItem('admin_token_expiry');
  if (!expiry) return true;
  return Date.now() > parseInt(expiry);
};

export const adminLogin = async (password) => {
  try {
    const response = await axios.post(`${API}/login`, { password });
    if (response.data.success) {
      const token = response.data.token;
      const expiresIn = response.data.expires_in || 86400; // default 24 hours in seconds
      
      // Store token and expiry time
      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_token_expiry', Date.now() + (expiresIn * 1000));
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const adminLogout = () => {
  localStorage.removeItem('admin_token');
  localStorage.removeItem('admin_token_expiry');
};

export const isAdminAuthenticated = () => {
  const token = localStorage.getItem('admin_token');
  if (!token) return false;
  
  // Check if token is expired
  if (isTokenExpired()) {
    adminLogout();
    return false;
  }
  
  return true;
};

export const getAllProjectsAdmin = async () => {
  try {
    const response = await axios.get(`${API}/projects`, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    return handleAuthError(error);
  }
};

export const createProjectAdmin = async (projectData) => {
  try {
    const response = await axios.post(`${API}/projects`, projectData, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    return handleAuthError(error);
  }
};

export const updateProjectAdmin = async (projectId, projectData) => {
  try {
    const response = await axios.put(`${API}/projects/${projectId}`, projectData, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    return handleAuthError(error);
  }
};

export const deleteProjectAdmin = async (projectId) => {
  try {
    const response = await axios.delete(`${API}/projects/${projectId}`, {
      headers: getAuthHeader()
    });
    return response.data;
  } catch (error) {
    return handleAuthError(error);
  }
};
